import type { ReactNode } from 'react'

interface Props {
  title: string
  sub?: string
  onBack?: () => void
  right?: ReactNode
}

export function AppBar({ title, sub, onBack, right }: Props) {
  return (
    <header className="appbar">
      {onBack && (
        <button type="button" className="icon-btn" onClick={onBack} aria-label="Quay lại">
          ‹
        </button>
      )}
      <div className="appbar-title">
        <h1>{title}</h1>
        {sub && <p>{sub}</p>}
      </div>
      {right}
    </header>
  )
}
